import React, { useState, useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { Button, Table, Spin, Checkbox, Popconfirm } from 'antd'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useSelector } from 'react-redux'

import Layout from '../components/layout/Layout'
import axiosInstance from '../utils/axiosInstance'
import { mainGrowthAreaArray, growthAreasObject, engagementTypeArray, leadershipSkillArray } from '../constants/focusAreaItems'

function FocusStacks() {
  const navigate = useNavigate()
  let { id } = useParams()
  const [searchParams] = useSearchParams()
  const organization = searchParams.get('organization')

  const auth = useSelector((state) => state.auth)

  const [loading, setLoading] = useState(false)
  const [loadingTwo, setLoadingTwo] = useState(false)
  const [stackItems, setStackItems] = useState([])
  const [focusArea, setOrgFocusArea] = useState({})
  const [createFocusAreaModal, setCreateFocusAreaModal] = useState(false)
  const [title, setTitle] = useState('')
  const [form, setForm] = useState({
    organization: organization,
    subTitle: '',
    points: '',
    quickDescription: '',
    category: '',
    level: '', // it will be string after selecting from select tag
    growthArea: '',
    specificGrowth: '',
  })

  const columns = [
    {
      title: 'Stack name',
      dataIndex: 'stackTitle',
      key: 'stackTitle',
      sorter: (a, b) => a.stackTitle.localeCompare(b.stackTitle),
    },
    // {
    //   title: 'Desccription',
    //   dataIndex: 'quickDescription',
    //   key: 'quickDescription',
    // },
    // Below one only for dev mode to get the item _id quickly
    // {
    //   title: '_id',
    //   dataIndex: '_id',
    //   key: '_id',
    // },
    {
      title: 'Clubs',
      key: 'organiztion',
      render: (data) => {
        let options = []

        auth.user.organizations.forEach((el) => {
          if (el == '666e715a9c9785b4dca98126') {
            options.push({ label: 'Grow or Die, Atlanta', value: el })
          } else if (el == '6766378368896b3a1f3c77c6') {
            options.push({ label: 'Leadership Network', value: el })
          } else if (el == '68405e73ab69418e6430990a') {
            options.push({ label: 'Elevate City Church', value: el })
          }
        })

        return (
          <div>
            {/* {JSON.stringify(data)} */}
            <Checkbox.Group
              options={options}
              defaultValue={data.organization}
              onChange={(val) => {
                if (auth.user.type !== 'coach') {
                  onClubCheckboxSelect(val, data._id)
                } else {
                  alert("Coach can't edit")
                  return
                }

                if (val.length == 0) {
                  alert("You cant't remove a focus Item from all clubs!")
                  window.location.reload()
                  return
                }
              }}
            />
          </div>
        )
      },
    },
    // {
    //   title: 'Disabled',
    //   dataIndex: 'disabled',
    //   key: 'disabled',
    //   render: (dis) => (dis ? 'TRUE' : 'FALSE'),
    // },
    {
      title: 'Created At',
      dataIndex: 'createdAt',
      key: 'createdAt',
      sorter: (a, b) => a.createdAt - b.createdAt,
      render: (createdAt) => new Date(createdAt).toLocaleString(),
    },

    ...(auth.user.type !== 'coach'
      ? [
          {
            title: 'Action',
            key: 'action',
            fixed: 'right',
            sorter: (a, b) => a.disabled - b.disabled,
            render: (_, record) => (
              <>
                <Button type="ghost" style={{ color: '#1677ff', cursor: 'pointer' }} onClick={() => handleEditStack(record._id)}>
                  Edit
                </Button>
                <Button type="ghost" style={{ color: '#722ed1', cursor: 'pointer' }} onClick={() => handleDuplicateStack(record._id)}>
                  Duplicate
                </Button>
                {record.disabled ? (
                  <Button type="ghost" style={{ color: '#1677ff', cursor: 'pointer' }} onClick={() => onDisable('false', `${record._id}`)}>
                    Publish
                  </Button>
                ) : (
                  <Popconfirm
                    title="Are you sure to delete this?"
                    description="This will no longer visible to users for add their stacks. But whoever already added this, they can track their progress."
                    onConfirm={() => onDisable('true', `${record._id}`)}
                    onCancel={() => {}}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button type="ghost" style={{ color: 'red', cursor: 'pointer' }}>
                      Disable
                    </Button>
                  </Popconfirm>
                )}
              </>
            ),
          },
        ]
      : []),
  ]

  const onDelete = async (subCategoryId) => {
    const response = await axiosInstance.delete(`/api/v1/focus/deleteSubFocus?subFocusId=${subCategoryId}`)
    alert('Success')
    window.location.reload()
  }
  const handlePublish = async (subCategoryId) => {
    const response = await axiosInstance.put(`/api/v1/focus/editSubFocus?subFocusId=${subCategoryId}`, { disabled: 'false' })
    alert('Success')
    window.location.reload()
  }

  const handleCreateStack = () => {
    navigate(`/createStack?id=${id}&organization=${organization}`)
  }

  const handleEditStack = (stackId) => {
    navigate(`/createStack?id=${id}&organization=${organization}&stackId=${stackId}`)
  }

  const handleDuplicateStack = (stackId) => {
    navigate(`/createStack?id=${id}&organization=${organization}&duplicateStackId=${stackId}`)
  }

  const getFocusAreaInfo = async (v) => {
    try {
      setLoading(true)

      const response = await axiosInstance.get(`/api/v1/focus/getFocusAreaById?focusId=${id}`)

      setOrgFocusArea(response.data.focusArea)

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const getStackItems = async () => {
    try {
      if (auth.user.organizations?.length) {
        setLoadingTwo(true)

        const response = await axiosInstance.get(`/api/v1/focusStacks/getAllStacks?focusAreaId=${id}`)

        setStackItems(response.data?.allStacks)

        setLoadingTwo(false)
      }
    } catch (e) {
      console.log(e)
      setLoadingTwo(false)
    }
  }

  const createSubFocus = async () => {
    try {
      // console.log(form)

      // Check if any field is empty
      const isEmptyField = Object.values(form).some((value) => {
        if (typeof u === 'string') {
          console.log('myVariable is a string')
          if (value.trim() === '') return true
        } else {
          console.log('myVariable is not a string')
          if (value === '') return true
        }
      })
      if (isEmptyField) {
        alert('All fields are required and cannot be empty.')
        return
      }
      if (!form.organization) {
        alert('Organization is not selected.')
        return
      }

      setLoading(true)

      const response = await axiosInstance.post(`/api/v1/focus/createSubFocus?focusId=${id}`, form)

      console.log(response.data)
      window.location.reload()

      setLoading(false)
    } catch (e) {
      console.log(e)
      setLoading(false)
    }
  }

  const onChange = (obj) => {
    console.log(obj)
    setForm((prev) => ({ ...prev, ...obj }))
  }

  const onClubCheckboxSelect = async (clubs, _id) => {
    console.log(clubs, _id)
    const response = await axiosInstance.put(`/api/v1/focusStacks/editFocusStack?id=${_id}`, { organization: clubs })
    console.log(response.data)
    alert('Success')
  }

  const onDisable = async (boolean, _id) => {
    const response = await axiosInstance.put(`/api/v1/focusStacks/editFocusStack?id=${_id}`, { disabled: boolean })
    alert('Success')
    window.location.reload()
  }

  useEffect(() => {
    getStackItems()
    getFocusAreaInfo()
  }, [])

  return (
    <Layout>
      <ArrowLeftOutlined
        style={{
          color: '#1677ff',
          fontSize: '1.5rem',
          marginBottom: 20,
          cursor: 'pointer',
        }}
        onClick={() => navigate('/focusAreas')}
      />
      {auth.user.type !== 'coach' && (
        <div>
          <Button type="primary" onClick={handleCreateStack} loading={loading}>
            Create Stack
          </Button>
        </div>
      )}
      {loading && <Spin size="small" />}
      {loadingTwo && (
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <Spin size="large" />
        </div>
      )}
      <br />
      <p style={{ fontSize: 28 }}>
        {focusArea?.title} (Total: {stackItems.length})
      </p>
      <Table
        scroll={{
          x: 1300,
        }}
        dataSource={stackItems}
        columns={columns}
        rowKey="_id"
        pagination={false}
      />
    </Layout>
  )
}

export default FocusStacks
